import {
    type FC
} from "react";
import {
    View
} from "react-native";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useItemGroupContext
} from "../../context";
import type {
    IItemSeparatorProps
} from "../../type";
import stylesheet from "../../stylesheet";

const ItemSeparator: FC<IItemSeparatorProps> = ({
    customTheme: customThemeProp,
    inset,
    style,
    ...props
}) => {
    const groupContext = useItemGroupContext();

    const {
        borders,
        colors
    } = NCoreUIKitTheme.useContext(customThemeProp ?? groupContext?.customTheme);

    return <View
        {...props}
        style={[
            style,
            stylesheet.separator,
            {
                backgroundColor: colors.content.border.subtle,
                height: borders.separator,
                marginStart: inset
            }
        ]}
        aria-hidden={true}
    />;
};
export default Object.assign(ItemSeparator, {
    itemPart: "separator" as const
});
